import Icon from 'veui/components/Icon'
import { IconEyeBright } from 'dls-icons-vue'

Icon.register('eye-bright', IconEyeBright)
